import { autoPaymentMethods, AutopayType } from '../../types';
import * as yup from 'yup';
import { PadAgreementServiceType } from './reporting';
export const autopayEnrollmentSchema = yup.object({
    enrollmentId: yup.string().optional(),
    epicClient: yup
        .object({
        merchantAccountId: yup.number().required(),
        epicClientId: yup.string().required().lowercase(),
        epicLookupCode: yup.string().required(),
        epicAccountName: yup.string().required(),
        postalCode: yup.string().required(),
        phoneNumber: yup.string().optional(),
        overrideCcFee: yup.number().integer().nullable(),
        overrideAchFee: yup.number().integer().nullable(),
        overrideEftFee: yup.number().integer().nullable(),
    })
        .required(),
    storedPaymentMethod: yup
        .object({
        recurringDetailReference: yup.string().required(),
        method: yup.mixed().oneOf(autoPaymentMethods).defined(),
    })
        .required(),
    // required for AutoPay enrollment with EFT
    padAgreementServiceType: yup
        .mixed()
        .oneOf([PadAgreementServiceType.Personal, PadAgreementServiceType.Commercial])
        .optional(),
    type: yup.mixed().oneOf(Object.values(AutopayType)).required(),
    policies: yup
        .array()
        .of(yup
        .object({
        epicPolicyId: yup.string().required().lowercase(),
        originalEpicPolicyId: yup.string().required().lowercase(),
        policyNumber: yup.string().required(),
        policyTypeCode: yup.string().required(),
        policyTypeDescription: yup.string().required(),
        dueDate: yup.string().required(),
    })
        .required())
        .when('type', ([type], schema) => (type === AutopayType.POLICIES ? schema.required() : schema.optional())),
    invoices: yup
        .array()
        .of(yup
        .object({
        invoiceNumber: yup.string().required(),
        dueDate: yup.string().required(),
        description: yup.string().required(),
    })
        .required())
        .when('type', ([type], schema) => (type === AutopayType.INVOICES ? schema.required() : schema.optional())),
});
export const autopayCancelSchema = yup.object({
    enrollmentId: yup.string().required(),
});
export const autopayDailyJobSchema = yup.object({
    limit: yup
        .object({
        tenantIds: yup.array().of(yup.string().required()).optional(),
        epicDataContexts: yup.array().of(yup.string().required().lowercase()).optional(),
        epicClientIds: yup.array().of(yup.string().required().lowercase()).optional(),
    })
        .optional()
        .default(undefined),
    date: yup.date().optional(),
    jobFilenameSuffix: yup.string().optional(),
    dryRun: yup.boolean().optional().default(false),
    // if object is null -> don't run that portion of job
    payments: yup
        .object({
        completePayments: yup.boolean().optional().default(true),
        allocateWithEpic: yup.boolean().optional().default(true),
        saveToDb: yup.boolean().optional().default(true),
        blockWithoutWarningEmail: yup.boolean().optional().default(true),
    })
        .nullable()
        .optional()
        .default({}),
    warningEmails: yup
        .object({
        sendEmails: yup.boolean().optional().default(true),
        saveToDb: yup.boolean().optional().default(true),
    })
        .nullable()
        .optional()
        .default({}),
    errorEmails: yup
        .object({
        sendEmails: yup.boolean().optional().default(true),
        saveToDb: yup.boolean().optional().default(true),
    })
        .nullable()
        .optional()
        .default({}),
});
//# sourceMappingURL=autopay.js.map